import { importBootstrap5 } from "@cervval.js/client-html5-ui/src/lookAndFeel/bootstrap5";
import { importFontAwesome6 } from "@cervval.js/client-html5-ui/src/lookAndFeel/fontAwesome6";
import { ensureLoaded } from "@cervval.js/common/src/tools/object.tools";
import "../../../assets/global.dom.scss"; // *.dom.scss files are injected in html by style-loader
import { AppIMXR } from "../components/app/app";

// Import fontAwesome
importFontAwesome6();

// Import bootstrap5 styling
importBootstrap5();

// Load App component class so that it is known by the CustomElement registry
ensureLoaded(AppIMXR);
